import React from 'react'
import Builder from './builder'
import Store from 'app/redux/store'
import { Provider } from 'redux-zero/react'
import { ToastContainer } from 'react-toastify'
import Sentry from 'components/utility/sentry'
import '@marketing-milk/frontend/dist/frontend.css'
import { BrowserRouter } from 'react-router-dom'
import Interceptor from 'components/utility/interceptor'
import { QueryClientProvider, QueryClient } from 'react-query'
import Auth0ProviderWithHistory from './Auth0ProviderWithHistory'
import { SessionContextProvider } from '@marketing-milk/frontend'
// @ts-ignore
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

const reactQueryClient = new QueryClient()

if (process.env.REACT_APP_POSTHOG_API_KEY) {
  posthog.init(`${process.env.REACT_APP_POSTHOG_API_KEY}`, {
    api_host: 'https://us.i.posthog.com',
    disable_session_recording: process.env.REACT_APP_MM_ENV !== 'production',
  })
}

export const App = () => (
  <QueryClientProvider client={reactQueryClient}>
    <SessionContextProvider>
      <Provider store={Store}>
        <BrowserRouter>
          <Auth0ProviderWithHistory>
            <PostHogProvider client={posthog}>
              <div style={{ height: '100%', width: '100%' }}>
                <ToastContainer style={{ zIndex: 5000 }} />
                <Interceptor />
                <Sentry />
                <Builder />
              </div>
            </PostHogProvider>
          </Auth0ProviderWithHistory>
        </BrowserRouter>
      </Provider>
    </SessionContextProvider>
  </QueryClientProvider>
)
